module.exports = __webpack_public_path__ + "static/media/rodrigo-dias.2ed1ca28.webp";